import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

interface ContainerProps {
  $disabled: boolean;
}

interface TagsWrapperProps {
  $error: boolean;
  $disabled: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: ${(props: ThemeProp & ContainerProps) => (props.$disabled ? 'none' : 'auto')};
  cursor: ${(props: ThemeProp & ContainerProps) => (props.$disabled ? 'not-allowed' : 'auto')};

  :hover {
    cursor: ${(props: ThemeProp & ContainerProps) => (props.$disabled ? 'not-allowed' : 'auto')};
  }
`;

export const Label = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.s};
  padding-left: 0.5rem;
  margin-bottom: 0.375rem;
`;

export const ErrorText = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.s};
  color: ${(props: ThemeProp) => props.theme.colors.errorRed};
  margin: 0.125rem 0 0 0.625rem;
  letter-spacing: -0.05em;
`;

const getBorderColor = (props: ThemeProp & TagsWrapperProps) => {
  if (props.$error) return props.theme.colors.errorRed;
  if (props.$disabled) return props.theme.colors.neutrals.c200;
  return props.theme.colors.neutrals.c200;
};

export const TagsWrapper = styled.div<TagsWrapperProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  width: 100%;
  min-height: 2.375rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  border: 1px solid ${(props: ThemeProp & TagsWrapperProps) => getBorderColor(props)};
  background-color: ${(props: ThemeProp & TagsWrapperProps) =>
    props.$disabled ? props.theme.colors.neutrals.c100 : 'white'};
  box-sizing: border-box;
  cursor: ${(props: ThemeProp & TagsWrapperProps) => (props.$disabled ? 'not-allowed' : 'text')};
`;

export const Tag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background-color: ${(props: ThemeProp) => props.theme.colors.primary.c100};
  color: ${(props: ThemeProp) => props.theme.colors.primary.c500};
  border-radius: 0.25rem;
  padding: 0.125rem 0.375rem;
  white-space: nowrap;
`;

export const TagLabel = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
`;

export const TagRemove = styled.span`
  cursor: pointer;
  line-height: 1;
  font-size: 14px;

  :hover {
    opacity: 0.7;
  }
`;

export const TagInput = styled.input`
  flex: 1;
  min-width: 5rem;
  border: none;
  outline: none;
  background: transparent;
  font-size: inherit;
  cursor: inherit;
`;
